import { useMutation } from '@tanstack/react-query'
import { switchAccount } from 'services/AuthService'

export const useSwitchAccountMutation = () => {
  return useMutation({ mutationFn: switchAccount })
}
